import type { SpinIndicator, SpinProps } from 'antd/lib/spin';
import cs from 'classnames';
import { Col } from '../col';
import { Row } from '../row';
import { Spin } from '../spin';

import styles from './loading.module.css';

export type LoadingProperties = {
  className?: string;
  indicator?: SpinIndicator;
  padding?: boolean;
  size?: SpinProps['size'];
  viewportHeight?: boolean;
};

const Loading = ({ className, indicator, padding, size, viewportHeight }: LoadingProperties) => (
  <Row
    align="middle"
    className={cs(styles['row-padding-hack'], { [styles['viewport-height'] ?? '']: viewportHeight })}
    justify="center"
  >
    <Col>
      <Spin
        className={cs(className, { [styles['padding-false'] ?? '']: padding === false })}
        indicator={indicator}
        size={size ?? 'large'}
      />
    </Col>
  </Row>
);

export default Loading;
